export const masterCategoryTranslations = {
  masterCategoriesTitle: 'Master Categories',
  searchPlaceholder: 'Search categories...',
  pushToProdButton: 'Push to Prod',
  addCategoryButton: 'Add Category',
  categoriesLoadedSuccess: 'Categories loaded successfully',
  categoriesLoadedError: 'Failed to load categories, using default data',
  categoryUpdatedSuccess: 'Category updated successfully',
  categoryAddedSuccess: 'Category added successfully',
  categorySaveError: 'Failed to save category',
  categoryDeleteConfirm: 'Are you sure you want to delete this category?',
  categoryDeletedSuccess: 'Category deleted successfully',
  categoryDeleteError: 'Failed to delete category',
  selectedCategoriesPushed: 'Selected categories pushed to production',
  failedToPushCategory: 'Failed to push category to production',
  editCategoryTitle: 'Edit Category',
  addNewCategoryTitle: 'Add New Category',
  languageLabel: 'Select Language (required)',
  productIdLabel: 'Product ID',
  categoryNameLabel: 'Category Name',
  categoryTextLabel: 'Category Text',
  categoryIdsLabel: 'Category IDs',
  carouselCidsLabel: 'Carousel CIDs',
  recentVideoCidsLabel: 'Recent Video CIDs',
  displayOrderLabel: 'Display Order',
  adultContentLabel: 'Adult Content',
  cancelButton: 'Cancel',
  saveButton: 'Save',
  addButton: 'Add',
  deleteButton: 'Delete',
  isShortLabel: 'Is Short',
  shortsCidContextMappingLabel: 'Shorts CID Context Mapping',
  circularCategoryThumbnailLabel: 'Circular Category Thumbnail',
}; 